
import React from 'react';
import { Link } from "react-router-dom";
import { UserAvatar } from "@/components/user/UserAvatar";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/auth";
import { Home, Menu } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";

interface MobileHeaderProps {
  className?: string;
}

export function MobileHeader({ className }: MobileHeaderProps) {
  const { isAdmin } = useAuth();
  const { toggleSidebar } = useSidebar();

  return (
    <header className={cn("md:hidden border-b border-border/40 sticky top-0 z-40 bg-background", className)}>
      <div className="h-14 px-4 flex items-center justify-between">
        {/* Menu button on left */}
        <button 
          onClick={toggleSidebar} 
          className="p-2 rounded-md hover:bg-muted"
          aria-label="Toggle menu"
        >
          <Menu className="h-5 w-5" />
        </button>
        
        {/* Logo in center */}
        <Link to="/" className="flex items-center justify-center text-xl font-medium text-foreground">
          <Home className="h-5 w-5 mr-2" />
          Farmvault
        </Link>
        
        {/* User avatar on right */}
        <div className="flex items-center">
          <UserAvatar size="sm" />
        </div>
      </div>
    </header>
  );
}
